<template>
<div class="chapter">
<div class="inner_page">
<p class="pn" id="pt1"><span class="epub-b">Book One</span></p>
<p class="pt"><span class="epub-b">Encounters</span></p>
<p class="pt"><span class="epub-b">1284</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?00f9c885